export const ClientConfigTab = {
  RECAP: 'recap',
  ONBOARDING: 'onboarding'
} as const;
export type ClientConfigTabType = (typeof ClientConfigTab)[keyof typeof ClientConfigTab];
